export enum LauncherType {
  HIDDEN = 'hidden',
  ICON = 'icon',
  BAR = 'bar',
  HOME_DESK = 'ca',
  CARDS = 'cards'
}
